<template>
  <div class="drop-down-modular-container">
    <button
      class="drop-down-modular-head"
      @click="!show_options ? toggleOverlay() : ''"
    >
      <slot name="head" />
    </button>

    <TransitionAccordion>
      <div
        v-if="show_options"
        class="drop-down-modular"
        :style="
        [ max_height ? { 'max-height': max_height + 'px', 'overflow': 'auto'} : {},
        {'border-radius':border_radius + 'px', 'z-index': z_index || 0}]
        "
        v-click-outside="toggleOverlay"
      >
        <div
          v-for="option, index in options"
          :key="`drop-down-modular-option-${option.id}`"
          :class="`drop-down-modular-option${getClassSuffix(option)}`"
          v-ripple="!option.disabled"
          :style="`
            border-radius: ${getBorderRadius(index)};
            cursor: ${option.disabled ? 'auto' : 'pointer'};
            padding: ${padding || '0 8px'};
            justify-content: ${justify_content || ''};
          `"
          @click="updateSelected(option)"
        >
          <button v-if="multiselect" @click.prevent.stop="stop()">
            <RadioButtonSquare
              :id="option.id"
              width="16"
              :is_active="selected_ids.includes(option.id)"
              @setActive="updateSelected(option)"
            >
              <template #content>
                <div
                  v-if="selected_ids.includes(option.id)"
                  class="drop-down-modular-option-checkbox"
                >
                  <TIcon
                    name="check"
                    class="drop-down-modular-option-checkbox-icon"
                    color="not-primary"
                    size="24"
                  />
                </div>
              </template>
            </RadioButtonSquare>
          </button>
          <TIcon
            v-if="option.icon"
            :name="option.icon"
            :color="getOptionColor(option)"
          />
          <TText
            v-if="option.text"
            class="drop-down-modular-nowrap"
            :text="option.text"
            :color="getOptionColor(option)"
            :font_weight="selected_ids.includes(option.id) ? 500 : 400"
            :line_height="2"
          />
          <TText
            v-if="option.value"
            class="drop-down-modular-nowrap"
            :value="option.value"
            :color="getOptionColor(option)"
            :font_weight="selected_ids.includes(option.id) ? 500 : 400"
            :line_height="2"
          />
          <TText
            v-if="!option.value && !option.text"
            class="drop-down-modular-nowrap"
            :text="option.id"
            :color="getOptionColor(option)"
            :font_weight="selected_ids.includes(option.id) ? 500 : 400"
            :line_height="2"
          />
          <button
            v-if="option.requires_pro && option.disabled"
            @click.prevent.stop="$router.push({ name: 'AccountSettings'})"
          >
            <TText
              class="drop-down-modular-nowrap"
              value="(PRO.user required)"
              :color="getColor()"
              small
              :underlined="true"
            />
          </button>
        </div>
      </div>
    </TransitionAccordion>
  </div>
</template>
<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
import RadioButtonSquare from '@/components/WorkPackageWIP/RadioButtonSquare.component.vue';

export default {
  props: [
    'options', // is array of objects, contains id (gets emitted), text (non translateable), value (translateable) icon, disabled, requires_pro
    'selected', // id of selected option
    'padding', // is string, gets fed as is in padding html inline of options
    'justify_content', // is string, gets fed as is in justify-content html inline of options
    'z_index', // is number, defines z-index of options
    // 'multiselect', // is boolean, is handled in computed
    'max_height', // is number, defines max-height of options
  ],

  components: {
    TIcon,
    TransitionAccordion,
    RadioButtonSquare,
  },

  mixins: [
    TColor,
  ],

  data: () => ({
    show_options: false,
    selected_option_ids: [],
    border_radius: 8,
  }),

  created() {
    // NOTE: selected_option_ids needs to be updated
    if(this.multiselect) {
      this.selected_option_ids = this.selected;
    }
  },

  computed: {
    multiselect() {
      let a = this.$attrs;
      if(a.multiselect !== undefined) {
        if(a.multiselect || a.multiselect === '')
          { return true; } }
      return false;
    },

    selected_ids() {
      if(Array.isArray(this.selected)) {
        return this.selected;
      }
      else {
        return [this.selected];
      }
    },
  },

  methods: {
    test(str) {
        console.log(str);
    },

    stop() {
      // NOTE: do nothing method workaround
    },

    toggleOverlay() {
      this.show_options = !this.show_options;
    },

    getBorderRadius(index) {
      if(index === 0) {
        return `${this.border_radius}px ${this.border_radius}px 0 0`;
      }
      if(index === this.options.length - 1) {
        return `0 0 ${this.border_radius}px ${this.border_radius}px`;
      }

      return 0;
    },

    getClassSuffix(option) {
      if(option.disabled) {
        return '-disabled';
      }

      if(this.selected_ids.includes(option.id)) {
        return '-current';
      }

      return '';
    },

    getOptionColor(option) {
      if(option.disabled) {
        return this.getTranspHexColor(this.getColor(), 0.5);
      }
      else {
        return this.getColor();
      }
    },

    updateSelected(option) {
      if(!option.disabled) {

        if(this.multiselect) {
          if(this.selected_option_ids.includes(option.id)) {
            this.selected_option_ids = this.selected_option_ids.filter(id => id != option.id);
          }
          else {
            this.selected_option_ids.push(option.id);
          }
          this.$emit('updateSelected', this.selected_option_ids);
        }

        else {
          this.$emit('updateSelected', option.id);
          this.show_options = false;
        }
      }
    },
  }
}
</script>
<style lang="css">
.drop-down-modular-container {
  padding: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-gap: 2px;
  position: relative;
}
.drop-down-modular-head {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.drop-down-modular {
  position: absolute;
  top: 100%;
  box-shadow: 0px 1px 4px black;
}
.drop-down-modular-option, .drop-down-modular-option-disabled, .drop-down-modular-option-current {
  display: flex;
  align-items: center;
  grid-gap: 4px;
  padding: 0 8px;
  transition: background-color 0.33s;
  background-color: var(--v-color-4-base);
}
.drop-down-modular-option-current {
  background-color: var(--v-color-2-base) !important;
}
.drop-down-modular-option:hover, .drop-down-modular-option-current:hover {
  background-color: var(--v-color-3-base) !important;
}
.drop-down-modular-option-checkbox {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.drop-down-modular-option-checkbox-icon {
  position: absolute;
}
.drop-down-modular-nowrap {
  white-space: nowrap;
}
</style>
